import React from 'react';

interface SsoConfigurationPreviewProps {
  domains: string[];
  onEdit: () => void;
  onCancel: () => void;
}

const SsoConfigurationPreview: React.FC<SsoConfigurationPreviewProps> = ({ domains, onEdit, onCancel }) => {
  const domainsValue = domains.join(', ');

  return (
    <div className="flex-one flex-box-column content-inner">
      <div className="panel-content flex-one">
        <div className="sso-configuration__item">
          <div className="sso-configuration__label">{t('sso.email-domain.label')}</div>
          <div className="sso-configuration__value">{domainsValue}</div>
        </div>
        <div className="sso-configuration__item">
          <div className="sso-configuration__label">{t('sso.idp-file.label')}</div>
          <div className="sso-configuration__value">{t('sso.idp-file.example')}</div>
        </div>
      </div>

      <div className="panel-footer flex-auto">
        <div className="flex-box-row">
          <button type="button" className="btn flex-one" onClick={onCancel}>
            {t('action.cancel')}
          </button>
          <button type="submit" className="btn btn-main flex-one" onClick={onEdit}>
            {t('action.edit')}
          </button>
        </div>
      </div>
    </div>
  );
};

export { SsoConfigurationPreview };
